import React from 'react';
import { Button, Box } from '@mui/material';
import LocationCityIcon from '@mui/icons-material/LocationCity';

interface ActionButtonsProps {
    salesReport: string;
    archiveOrders: string;
    isLoading: boolean;
    isProcessed: boolean;
    onStart: () => void;
    onDownload: () => void;
    onOpenCityManager: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
    salesReport,
    archiveOrders,
    isLoading,
    isProcessed,
    onStart,
    onDownload,
    onOpenCityManager
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button
                variant="contained"
                disabled={!salesReport || !archiveOrders || isLoading}
                onClick={isProcessed ? onDownload : onStart}
                sx={{
                    mt: 1, mb: 1,
                    bgcolor: isProcessed ? 'warning.main' : 'primary.main',
                    '&:hover': {
                        bgcolor: isProcessed ? 'warning.dark' : 'primary.dark',
                    }
                }}
            >
                {isLoading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <span>Обработка...</span>
                    </Box>
                ) : isProcessed ? 'Скачать' : 'Начать'}
            </Button>
            
            {localStorage.getItem('role') === 'admin' && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onOpenCityManager}
                    startIcon={<LocationCityIcon />}
                    sx={{ position: 'absolute', right: 15, bottom: 15 }}
                >
                    Управление городами
                </Button>
            )}
        </Box>
    );
};

export default ActionButtons;
